import React from 'react';
import styles from './Loader.module.css'

const Loader = () => {
  return (
      <div className={styles.loadingOverlay}>
        <div className={styles.loadingSpinner}></div>
        <p>Loading...</p>
      </div>
  );
};

export default Loader;
